import React, { useState, useRef, useEffect } from 'react';

const SearchableSelect = ({ options, value, onChange, placeholder, disabled }) => {
	const [search, setSearch] = useState('');
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		const handler = e => {
			if (ref.current && !ref.current.contains(e.target)) {
				setOpen(false);
				setSearch('');
			}
		};
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, []);

	const filtered = options.filter(o => o.name?.toLowerCase().includes(search.toLowerCase()));
	const selected = options.find(o => String(o.id) === String(value));

	return (
		<div style={{ position: 'relative' }} ref={ref}>
			<input
				type="text"
				value={open ? search : selected ? selected.name : ''}
				placeholder={placeholder}
				disabled={disabled}
				onChange={e => {
					setSearch(e.target.value);
					setOpen(true);
				}}
				onFocus={() => {
					if (!disabled) setOpen(true);
				}}
				style={{
					height: '45px',
					borderRadius: '4px',
					border: '1px solid #ced4da',
					padding: '0 12px',
					width: '100%',
					background: disabled ? '#e9ecef' : '#fff',
					color: '#333',
					cursor: disabled ? 'not-allowed' : 'pointer',
					boxSizing: 'border-box',
				}}
			/>
			{open && (
				<div
					style={{
						position: 'absolute',
						top: '100%',
						left: 0,
						right: 0,
						maxHeight: '200px',
						overflowY: 'auto',
						background: '#fff',
						border: '1px solid #ced4da',
						borderRadius: '0 0 4px 4px',
						zIndex: 1050,
						boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
					}}
				>
					{filtered.length === 0 ? (
						<div style={{ padding: '10px 12px', color: '#999', fontSize: '13px' }}>No results</div>
					) : (
						filtered.map(o => (
							<div
								key={o.id}
								onClick={() => {
									onChange(o.id);
									setOpen(false);
									setSearch('');
								}}
								style={{
									padding: '10px 12px',
									cursor: 'pointer',
									fontSize: '14px',
									color: '#333',
									borderBottom: '1px solid #f0f0f0',
									background: String(o.id) === String(value) ? '#eef2ff' : '#fff',
								}}
								onMouseEnter={e => (e.target.style.background = '#f5f5f5')}
								onMouseLeave={e => (e.target.style.background = String(o.id) === String(value) ? '#eef2ff' : '#fff')}
							>
								{o.name}
							</div>
						))
					)}
				</div>
			)}
		</div>
	);
};

export default SearchableSelect;
